import type { i18n as I18n } from 'i18next';
import { MotionConfig } from 'motion/react';
import type { ReactNode } from 'react';

import { I18nProvider } from './I18nProvider';
import { PlanProvider } from './PlanProvider';
import { QueryProvider } from './QueryProvider';
import { ToastProvider } from './ToastProvider';

/**
 * Single composition point for every app-wide context.
 *
 * Order matters: i18n wraps everything so any provider below can translate,
 * and the query client sits above the feature state that reads from it.
 *
 * MotionConfig honours the visitor's prefers-reduced-motion setting, so the
 * entrance and parallax animations resolve straight to their end state for
 * anyone who has asked the OS to reduce motion.
 */
export const AppProviders = ({ i18n, children }: { i18n: I18n; children: ReactNode }) => (
  <I18nProvider i18n={i18n}>
    <QueryProvider>
      <PlanProvider>
        <MotionConfig reducedMotion="user">
          <ToastProvider>{children}</ToastProvider>
        </MotionConfig>
      </PlanProvider>
    </QueryProvider>
  </I18nProvider>
);
